// extracted by mini-css-extract-plugin
export var bubble = "_41-0";
export var container = "_41-f";
export var contrastBorder = "_41-g";
export var greyOut = "_41-2";
export var initialsColor0 = "_41-3";
export var initialsColor1 = "_41-4";
export var initialsColor10 = "_41-d";
export var initialsColor11 = "_41-e";
export var initialsColor2 = "_41-5";
export var initialsColor3 = "_41-6";
export var initialsColor4 = "_41-7";
export var initialsColor5 = "_41-8";
export var initialsColor6 = "_41-9";
export var initialsColor7 = "_41-a";
export var initialsColor8 = "_41-b";
export var initialsColor9 = "_41-c";
export var initialsWrapper = "_41-1";
export var large = "_41-l";
export var medium = "_41-k";
export var mediumSmall = "_41-j";
export var mediumSmallMedium = "_41-o";
export var micro = "_41-h";
export var small = "_41-i";
export var tiny = "_41-n";
export var xTiny = "_41-m";